import { cspController } from '@/apis/core';

export const getCspNameAutocompleteOptions = async (
  type: 'displayName' | 'companyName',
  value: string
): Promise<string[]> => {
  const response = await cspController.getCspSuggestions({
    prefix: type === 'displayName' ? value : undefined,
    companyNamePrefix: type === 'companyName' ? value : undefined,
    limit: 20,
  });
  return (
    response?.map((suggestion) =>
      type === 'displayName' ? suggestion.cspName : suggestion.cspCompanyName
    ) || []
  );
};
